import styled from 'styled-components';

export const Container = styled.div`
  > fieldset {
    margin-bottom: ${({ theme }) => `${theme.x2space}rem`};
  }
`;
